<template>
  <aside class="main-sidebar">

    <!-- sidebar: style can be found in sidebar.less -->
    <section class="sidebar">

      <!-- Sidebar user panel (optional) -->
      <div class="user-panel">
        <div class="pull-left image">
          <img src="../../static/img/avatar5.png" class="user-image" alt="User Image">
        </div>
        <div class="pull-left info">
          <div>
            <p class="white">{{ username }}</p>
          </div>
          <a href="javascript:;">
            <i class="fa fa-circle text-success"></i> {{roles}}
          </a>
        </div>
      </div>

      <!-- search form (Optional) -->
      <!-- <form v-on:submit.prevent class="sidebar-form">
        <div class="input-group">
          <input type="text"
            name="search"
            id="search"
            class="search form-control"
            data-toggle="hideseek" p
            laceholder="Search Menus"
            data-list=".sidebar-menu">
          <span class="input-group-btn">
            <button type="submit" name="search" id="search-btn" class="btn btn-flat">
              <i class="fa fa-search"></i>
            </button>
          </span>
        </div>
      </form> -->
      <!-- /.search form -->

      <!-- Sidebar Menu -->
      <sidebar-menu />
      <!-- /.sidebar-menu -->
    </section>
    <!-- /.sidebar -->
  </aside>
</template>
<script>
import SidebarMenu from './SidebarMenu'
import { webapi, HTTP, baseURL,serverURL} from '../api/api'
export default {
  name: 'Sidebar',
  props: ['displayName', 'pictureUrl'],

  components: { SidebarMenu },
  data: function () {
    return {
      username:'',
      roles:window.localStorage.getItem('roles')== "ROLE_ADMIN"&&window.localStorage.getItem('user')== "admin" ? '管理员' :window.localStorage.getItem('roles')== "ROLE_ADMIN"&&window.localStorage.getItem('user')!= "admin" ? '操作员' : window.localStorage.getItem('roles')== "ROLE_USER" ? '用户':"未知",
    }
  },
  methods: {
    getCommonName(){

      let para = { username: window.localStorage.getItem('user') };
     webapi.post('/user/getCommonName',para).then((res) => {
        this.username = res.data.commonName
        console.log(this.username)
      }).catch(error => {
      })
    }
  },
     mounted() {
      // this.getCommonName();
    }
}
</script>
<style>
  .user-panel .image img {
    border-radius: 50%;
  }
</style>



// WEBPACK FOOTER //
// Sidebar.vue?8b94d668